export default [
    {
        text: 'Windows',
        value: 'windows_desktop',
        v_selected: null,
        device: 'desktop',
        ver: null,
        icon: 'mdi-microsoft-windows'
    },
    {
        text: 'iPhone (iOS)',
        value: 'ios_iphone',
        v_selected: "14.0",
        device: 'mobile',
        ver: [
            '8.0',
            '9.0',
            '10.0',
            '11.0',
            '12.0',
            '13.0',
            '14.0',
            '15.0',
            '16.0',
            '17.0',
        ],
        icon: 'mdi-apple'
    },
    {
        text: 'iPad (iOS)',
        value: 'ios_ipad',
        v_selected: "14.0",
        device: 'tablet',
        ver: [
            '8.0',
            '9.0',
            '10.0',
            '11.0',
            '12.0',
            '13.0',
            '14.0',
            '15.0',
            '16.0',
            '17.0',
        ],
        icon: 'mdi-tablet'
    },
    {
        text: 'Phone (Android)',
        value: 'android_phone',
        v_selected: "11.0",
        device: 'mobile',
        ver: [
            '4.0',
            '5.0',
            '6.0',
            '7.0',
            '8.0',
            '9.0',
            '10.0',
            '11.0'
        ],
        icon: 'mdi-android'
    },
    {
        text: 'Tablet (Android)',
        value: 'android_tablet',
        v_selected: "11.0",
        device: 'tablet',
        ver: [
            '4.0',
            '5.0',
            '6.0',
            '7.0',
            '8.0',
            '9.0',
            '10.0',
            '11.0'
        ],
        icon: 'mdi-tablet'
    }

  ]
  